
import ShopService from '../services/shop-service';
import CheckoutService from './CheckoutService';
import CheckoutClientLogin from './checkout-client-login.vue'

export default {
	components: {
		CheckoutClientLogin,
	},
	props: ['modal','order'],
	// emits: ['go'],
	data() {
		return {
			CheckoutService,
			saleAreas: this.getSaleAreas(),
		};
	},
	methods: {
		getSaleAreas() {
			let arr = this.order.shop.sale_areas;
			for(let i in this.order.shop.sister_shops) {
				arr = arr.concat(this.order.shop.sister_shops[i].sale_areas);
			}
			let saleAreas = {};
			for(let j in arr) {
				let area = arr[j];
				if (area.pivot.ModeId == this.order.SaleModeId && !saleAreas[area.SaleAreaId]) {
					if (area.SaleAreaId != ShopService.SALE_AREAS.RESTAURANT) {
						saleAreas[area.SaleAreaId] = area;
					}
				}
			}
			return saleAreas;
		},
	}
}
